export default "__VITE_ASSET__DtntZFNj__"